import React, {useEffect, useRef, useState} from "react";
import styles from "./chat.module.css";
import {Header} from "../header/header";
import {ChatContainer} from "../chat-container/chat-container";
import {ChatInput} from "../chat-input/chat-input";
import {Assistant} from "../assistant/assistant";
import {useDispatch, useSelector} from "react-redux";
import {
  addMessage,
  addResponse,
  clearOraculIsTyping,
  clearWaitingResponse,
  setOraculIsTyping,
  setWaitingResponse,
} from "../../store/stateSlice";
import {answers} from "../../data";
import {MessageOracular} from "../message-oracular/message-oracular";
import {MessageUser} from "../message-user/message-user";
import {getRandomInt} from "../../../../util";

const Chat = () => {
  const messages = useSelector((store) => store.messenger.messages);
  const oracular = useSelector((store) => store.messenger.oracular);
  const waitingResponse = useSelector((store) => store.messenger.waitingResponse);
  const isOracularTyping = useSelector((store) => store.messenger.isOracularTyping);
  const dispatch = useDispatch();
  const [currentAnswerIdx, setCurrentAnswerIdx] = useState(1);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ block: "end", behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isOracularTyping]);

  const postResponse = () => {
    dispatch(addResponse(answers[currentAnswerIdx]));
    dispatch(clearOraculIsTyping());
    dispatch(clearWaitingResponse());
    setCurrentAnswerIdx(currentAnswerIdx + 1);
  };

  useEffect(() => {
    if (waitingResponse && currentAnswerIdx < answers.length) {
      setTimeout(() => {
        dispatch(setOraculIsTyping());
        setTimeout(() => {
          postResponse();
        }, getRandomInt(2000, 3000));
      }, getRandomInt(1000, 2000));
    }
  }, [waitingResponse, currentAnswerIdx]);

  const handleOnSend = (text) => {
    if (text) {
      if (isOracularTyping) {
        dispatch(clearOraculIsTyping());
      }
      dispatch(addMessage(text));
      dispatch(setWaitingResponse());
    }
  };

  return (
    <div className={styles.chat}>
      <Header />
      <Assistant />
      <ChatContainer>
        {messages.map((message, idx) =>
          message.sender === "oracular" ? (
            <MessageOracular key={idx}>{message.text}</MessageOracular>
          ) : (
            <MessageUser key={idx}>{message.text}</MessageUser>
          )
        )}
        {isOracularTyping && (
          <span style={{ color: "black" }}>{oracular.name} is typing...</span>
        )}
        <div ref={messagesEndRef} />
      </ChatContainer>
      <ChatInput onSend={handleOnSend} />
    </div>
  );
};

export { Chat };
